"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormSelect", {
    enumerable: true,
    get: function() {
        return FormSelect;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _FormInputGroupContext = require("../FormInputGroup/FormInputGroupContext");
const _useDropdownChevronBackground = require("../../../hooks/useDropdownChevronBackground");
const _useInputBorderCss = require("../useInputBorderCss");
const _useInputPadding = require("../useInputPadding");
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormSelect = (param)=>{
    let { children, dropdownIcon, ...props } = param;
    const [value, setValue] = (0, _react.useState)(typeof props.value === "string" ? props.value : "");
    const { id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const { colors } = (0, _Theme.useTheme)();
    const fontColor = value === "" ? colors.muted1 : "inherit";
    const defaultBg = (0, _useDropdownChevronBackground.useDropdownChevronBackground)({
        color: value === "" ? colors.muted1 : "#333"
    });
    const dropdownBg = dropdownIcon != null ? dropdownIcon({
        color: value === "" ? colors.muted1 : "#333"
    }) : defaultBg;
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        rounded: props.rounded
    });
    const padding = (0, _useInputPadding.useInputPadding)({
        right: "32px"
    });
    const { hasSuffix } = (0, _react.useContext)(_FormInputGroupContext.FormInputGroupContext);
    (0, _react.useEffect)(()=>{
        setValue(typeof props.value === "string" ? props.value : "");
    }, [
        props.value
    ]);
    var _props_id, _props_className;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("select", {
        ...props,
        id: (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id,
        "aria-describedby": hintId,
        onChange: (e)=>{
            setValue(e.target.value);
            if (props.onChange != null) {
                props.onChange(e);
            }
        },
        className: _style.default.dynamic([
            [
                "81d01592959a4027",
                [
                    padding.shorthand,
                    fontColor,
                    dropdownBg,
                    hasSuffix ? "0" : "11px",
                    colors.grayscale[3],
                    padding.top,
                    padding.bottom
                ]
            ]
        ]) + " " + "".concat((_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "", " ").concat(borderCss.className)
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "81d01592959a4027",
        dynamic: [
            padding.shorthand,
            fontColor,
            dropdownBg,
            hasSuffix ? "0" : "11px",
            colors.grayscale[3],
            padding.top,
            padding.bottom
        ]
    }, "select.__jsx-style-dynamic-selector{line-height:22px;padding:".concat(padding.shorthand, ";-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;display:inline-block;cursor:pointer;float:none;outline:none;width:100%;font-size:14px;color:").concat(fontColor, ";background:").concat(dropdownBg, " right ").concat(hasSuffix ? "0" : "11px", " center/16px 16px no-repeat;-o-text-overflow:ellipsis;text-overflow:ellipsis}select.__jsx-style-dynamic-selector:disabled{cursor:unset;background-color:").concat(colors.grayscale[3], "}select.__jsx-style-dynamic-selector option{color:#333}select.__jsx-style-dynamic-selector:first-child{padding-top:").concat(padding.top, "}select.__jsx-style-dynamic-selector:last-child{padding-bottom:").concat(padding.bottom, "}")), borderCss.styles);
};

//# sourceMappingURL=FormSelect.js.map